import { observer } from 'mobx-react-lite';
import CategoriesFilterDropdown from '@features/categories/components/CategoriesFilterDropdown/CategoriesFilterDropdown';
import FilterSortState from '@features/categories/mobx/state/FilterSortState';
type PropsType = {
  sorting: FilterSortState;
};
const CategoriesSortSelect = observer(({
  sorting
}: PropsType) => <CategoriesFilterDropdown filter={sorting} withAppTranslation />);
export default CategoriesSortSelect;